import React, { memo } from 'react';
import Checkbox from '@JohnLewisPartnership/jl-design-system/components/checkbox/Checkbox';

export type Props = {
  id: string;
  ariaLabel: string;
  checked: boolean;
  disabled: boolean;
  onCompareClick: () => void;
};

const CompareCheckbox = ({
  id,
  ariaLabel,
  checked,
  disabled,
  onCompareClick,
}: Props) => {
  const compareId = `compare-${id}`;

  return (
    <Checkbox
      id={compareId}
      // prettier-ignore
      label={(
        <>
          Compare
          <span className="visuallyHidden">{ariaLabel}</span>
        </>
      )}
      isControlled
      name={compareId}
      checked={checked}
      onChange={onCompareClick}
      disabled={disabled}
    />
  );
};

export default memo(CompareCheckbox);
